module.exports = __webpack_public_path__ + "img/seta.177c11df.svg";